import(/* webpackMode: "eager" */ "/codebuild/output/src234616500/src/app/home/page.tsx");
